import React, { createContext, useContext, useMemo } from 'react';

type TableConfig = {
  defaultPageSize: number;
  pageSizeOptions: number[];
  defaultDensity: 'compact' | 'normal' | 'comfortable';
};

type AppConfig = {
  table: TableConfig;
};

type SettingsContextValue = {
  appConfig: AppConfig;
};

const defaultConfig: AppConfig = {
  table: {
    defaultPageSize: 20,
    pageSizeOptions: [10, 20, 50, 100],
    defaultDensity: 'normal',
  },
};

const SettingsContext = createContext<SettingsContextValue>({
  appConfig: defaultConfig,
});

export function SettingsProvider({ children }: { children: React.ReactNode }) {
  const value = useMemo(() => ({ appConfig: defaultConfig }), []);
  return (
    <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>
  );
}

export function useSettings(): SettingsContextValue {
  return useContext(SettingsContext);
}
